import { LOGGER_LOG } from '../constants'

// eslint-disable-next-line
export function actionLoggerLog(message) {
    return {
        type: LOGGER_LOG,
        payload: message,
    }
}



// WEBPACK FOOTER //
// ./src/actions/logger.js